export default __webpack_public_path__ + "static/m-feature-5-8eebe73595002bf374a32919f3f3245e.png";